import { render, staticRenderFns } from "./telType.vue?vue&type=template&id=d34d0dd2"
import script from "./telType.vue?vue&type=script&lang=js"
export * from "./telType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports